import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Bill } from "@common/types/bill";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CopyOnClick } from "@design-system/CopyOnClick/CopyOnClick";
import classNames from "classnames";
import { useIdCopy } from "@hooks/useIdCopy";
import styles from "./VendorCell.module.scss";

export const VendorCell = memo(
    ({ row }: CellContext<ViewTableFeatures, Bill, any>) => {
        const bill = row.original;
        const { getCopyProps: getCopyPropsCounterparty } = useIdCopy({
            label: "Counterparty",
        });

        return (
            <ViewTableCell>
                <div className={styles.vendorContent}>
                    {bill.counterparty ? (
                        <>
                            <span
                                className={styles.vendorName}
                                {...getCopyPropsCounterparty(
                                    bill.counterparty?.id,
                                )}
                            >
                                {bill.counterparty?.name}
                            </span>
                            {bill.counterparty?.email && (
                                <CopyOnClick
                                    className={classNames(
                                        styles.vendorEmail,
                                        styles.leftAligned,
                                    )}
                                    value={bill.counterparty?.email}
                                    tooltipText="Copy email"
                                    stopPropagation
                                >
                                    {bill.counterparty?.email}
                                </CopyOnClick>
                            )}
                        </>
                    ) : (
                        "-"
                    )}
                </div>
            </ViewTableCell>
        );
    },
);
